import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService, UserService, OperationsService, AuthenticationService, StorageService, LoansService, } from '../../_services/index';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { OptionsserviceService } from '../../_services/optionsservice.service';

@Component({
  selector: 'app-invitemultiplecustomers',
  templateUrl: './invitemultiplecustomers.component.html',
  styleUrls: ['./invitemultiplecustomers.component.css']
})
export class InvitemultiplecustomersComponent implements OnInit {
  endDate = '1561330800000';
  showWhatsapp = false;
  @Input('currentUser') currentUser: any;
  request = {
    'name': '',
    'email': '',
    'product_id':''
  }
  whatsapp = {
    'send_to_whatsapp': false,
    'whatsapp_number': '',
    'whatsapp_message': ''
  }
  addingInvite = true;
  coolSubmit = false;
  loading = false;
  success = false;
  invites = [];
  result:any;
  view='link';
  generated_link='';
  constructor(public toastr: ToastrService, public loansService: LoansService,
    public fb: FormBuilder, public operationsService: OperationsService,
    public storageService: StorageService, public optionsService: OptionsserviceService, public dataService: DataService) {

  }

  ngOnInit() {
    this.request.name = '';
    this.request.email = '';
    this.initialize();
  }
  initialize(){
    this.loading = true;
    this.operationsService.initializeInvites(this.currentUser.token)
      .subscribe(data => {
        this.loading = false;
        this.result = data.data;
      });
  }
  generateLink(value, valid){
    this.loading = true;
    this.operationsService.generateInviteLink(this.currentUser.token, value)
      .subscribe(data => {
        this.loading = false;
        this.view = 'link';
        this.generated_link = data.data.data.link;
      });
  }
  saveInterestRateBand(value, valid) {
    this.invites.push(value);
    this.request.name = '';
    this.request.email = '';
    this.addingInvite = false;
    this.view = 'invite';
  }
  deleteInvite(invite) {
    console.log(this.invites, invite);
    this.invites = this.invites.filter(inv => inv.email !== invite.email);
  }
  openCoolSubmit() {
    this.coolSubmit = true;
  }
  sendInvite() {
    //this.loading = true;
    // this.operationsService.sendLoanInvites(this.currentUser.token, this.invites, this.whatsapp)
    //   .subscribe(data => {
    //     this.loading = false;
    //     if (data.status === true) {
    //       this.showSuccess(data.message)
    //     } else {
    //       this.showError(data.message)
    //     }
    //     this.whatsapp.send_to_whatsapp = false;
    //     this.whatsapp.whatsapp_message = '';
    //     this.whatsapp.whatsapp_number = '';
    //     this.invites = [];
    //   });
    this.loading = true;
    this.loading = false;
    this.showSuccess('Invites are now being sent.');
    this.success = true;
    this.operationsService.sendLoanInvites(this.currentUser.token, this.invites, this.whatsapp);
    this.dataService.multipleInvitesSent.emit()
  }
  sendMultiple() {
    this.dataService.inviteMultipleCustomers.emit();
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }
  showingWhatsapp() {
    this.showWhatsapp = !this.showWhatsapp;
    this.whatsapp.send_to_whatsapp = !this.whatsapp.send_to_whatsapp
  }
}
